const footerLinks = [
  { label: '首页', href: '#home' },
  { label: '平台介绍', href: '#platform' },
  { label: '核心功能', href: '#features' },
  { label: '热门内容', href: '#content' },
  { label: '使用指南', href: '#guide' },
  { label: '常见问题', href: '#faq' },
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <a href="#home" className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-live-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg">歪歪官方网站</span>
            </a>
            <p className="mt-4 text-sm text-background-50/70 leading-relaxed">
              歪歪官方网站入口导航，为你整理平台入口、地址、首页、网址与登录方式，收藏本页即可随时一键直达。
            </p>
          </div>

          <div>
            <h4 className="text-base text-background-50">快速导航</h4>
            <div className="mt-4 grid grid-cols-2 gap-x-6 gap-y-3">
              {footerLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  className="text-sm text-background-50/70 hover:text-accent-300 whitespace-nowrap transition-colors"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-base text-background-50">官方入口</h4>
            <p className="mt-4 text-sm text-background-50/70 leading-relaxed">
              为保障账号与财产安全，请务必通过正规渠道访问歪歪官方网站并完成登录与充值。
            </p>
            <a
              href="https://www.yy.com"
              target="_blank"
              rel="nofollow noopener"
              className="mt-4 inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-accent-500 text-foreground-950 text-sm whitespace-nowrap hover:bg-accent-600 transition-colors"
            >
              <i className="ri-external-link-line" aria-hidden="true"></i>
              前往官方首页
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/60">本站为歪歪官方网站的入口导航页面，相关平台信息以官方公布为准。</p>
          <a
            href="#home"
            className="inline-flex items-center gap-2 text-xs text-background-50/70 hover:text-accent-300 whitespace-nowrap"
          >
            <i className="ri-arrow-up-line" aria-hidden="true"></i>
            返回顶部
          </a>
        </div>
      </div>
    </footer>
  );
}